var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',[_c('v-main',[(_vm.appType != 'User')?_c('Header'):_vm._e(),(_vm.appType == 'User')?_c('SellerHeader'):_vm._e(),_c('router-view'),_c('Footer')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }